/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import { EditIcon } from '../components/Icons/EditIcon';
import i18n from '../i18n';
import { FileDoneOutlined, ThunderboltOutlined } from '@ant-design/icons';

export const TEST_SETS_SEARCH_PARAMS = {
  ACTIVE_TEST: 'activeTestSet',
  CREATE_TEST: 'createTestSet',
  ACTIVE_TAB: 'activeTestTab',
  ACTIVE_TEST_NAME: 'activeTestName'
};

export const TEST_SET_TABS = {
  TEST_SET: {
    key: 'testSet',
    label: i18n.t('Test Set', { context: 'NLP test set tab name' }),
    renderIcon: (props) => <EditIcon {...props} />
  },
  TEST_RUN: {
    key: 'testRun',
    label: i18n.t('Run Test', { context: 'NLP test set tab name' }),
    renderIcon: (props) => <ThunderboltOutlined {...props}/>
  },
  TEST_RESULTS: {
    key: 'testResults',
    label: i18n.t('Results', { context: 'NLP test set tab name' }),
    renderIcon: (props) => <FileDoneOutlined {...props} />
  }
};

